(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Layer_Shapefile_Binning = (function(superClass) {
    extend(Layer_Shapefile_Binning, superClass);

    function Layer_Shapefile_Binning() {
      return Layer_Shapefile_Binning.__super__.constructor.apply(this, arguments);
    }

    Layer_Shapefile_Binning.prototype.init = function() {
      this.layoutUrl = 'backend/grower/layers/shapefile/load-layout';
      this.saveUrl = 'backend/grower/layers/shapefile/set-binning';
      this.destroyOnSave = false;
      this.slideUpForm = false;
      this.refreshNavHandler = false;
      return this.createDialog();
    };

    Layer_Shapefile_Binning.prototype.afterLoadLayout = function() {
      this.saveData.id = this.loadLayoutPostOptions.id;
      this.submitAction = function() {
        return this.save('Saving...');
      };
      this.successAction = (function(_this) {
        return function() {
          var layer, nickname;
          nickname = "shapefile" + _this.loadLayoutPostOptions.layer_id;
          layer = _this.parent.activeSubHandlers[nickname];
          if (layer) {
            layer.binning = _this.dialog.find('.binning_attr').val();
            return layer.refresh();
          }
        };
      })(this);
      return this.openDialog();
    };

    return Layer_Shapefile_Binning;

  })(DialogHandler);

}).call(this);
